export default __webpack_public_path__ + "static/media/actividad-40.05a19b40.mp3";